import axios from 'axios';

import { API_URL } from '../../constants/constants';
import {
  EventCheckInCodeDto,
  EventCheckInDto,
  EventCheckInResponseDto,
} from '../../types/dto/event-check-in.dto';

export class EventCheckIn {
  async getCheckInCode(eventId: string): Promise<EventCheckInCodeDto> {
    const params = new URLSearchParams();
    params.append('eventId', eventId);

    const response = await axios({
      method: 'GET',
      url: `${API_URL}/api/event-check-in`,
      responseType: 'json',
      params,
    });

    return response.data as EventCheckInCodeDto;
  }

  async getCheckIns(eventId: string): Promise<EventCheckInDto[]> {
    const params = new URLSearchParams();
    params.append('eventId', eventId);

    const response = await axios({
      method: 'GET',
      url: `${API_URL}/api/event-check-in/list`,
      responseType: 'json',
      params,
    });

    return response.data as EventCheckInDto[];
  }

  async checkIn(eventId: string): Promise<EventCheckInResponseDto> {
    const params = new URLSearchParams();
    params.append('eventId', eventId);

    const response = await axios({
      method: 'POST',
      url: `${API_URL}/api/event-check-in`,
      responseType: 'json',
      params,
    });

    return response.data;
  }
}
